import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'home',
    meta: {
        title: '战略性新兴产业及未来产业数据库平台'
    },
    component: () =>
        import ('../views/Home')
}, {
    path: '/introduce',
    name: 'introduce',
    meta: {
        title: '战略性新兴产业及未来产业数据库平台'
    },
    component: () =>
        import ('../views/introduce/index')
}, {
    path: '/list',
    name: 'list',
    meta: {
        title: '战略性新兴产业及未来产业数据库平台'
    },
    component: () =>
        import ('../views/list/index')
}, {
    path: '/hotFocus',
    name: 'hotFocus',
    meta: {
        title: '战略性新兴产业及未来产业数据库平台'
    },
    component: () =>
        import ('../views/hotFocus/index')
}, {
    path: '/onlineAnnouncement',
    name: 'onlineAnnouncement',
    meta: {
        title: '战略性新兴产业及未来产业数据库平台'
    },
    component: () =>
        import ('../views/onlineAnnouncement/index')
}]

const router = new VueRouter({
    routes,
    mode: 'history',
    base: '/',
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

export default router